exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  -ms-flex: 1 0 40px;\n      flex: 1 0 40px;\n  max-height: 70px;\n  background-color: #000000;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: row;\n      flex-flow: row; }\n  :host .close-container {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.8); }\n    :host .close-container img {\n      position: absolute;\n      top: 5px;\n      right: 5px;\n      width: 50px; }\n  :host .button, :host .drawing-no {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n    color: #ffffff;\n    margin: 5px 0; }\n  :host .button {\n    border-right: 1px solid #747f8f;\n    -ms-flex: 1 1 80px;\n        flex: 1 1 80px;\n    -ms-flex-flow: column;\n        flex-flow: column;\n    font-size: 12px;\n    font-weight: bold; }\n    :host .button.disabled {\n      color: rgba(255, 255, 255, 0.5);\n      pointer-events: none; }\n    :host .button:last-of-type {\n      border-right: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/menu-bar/menu-bar.component.scss
// module id = ../../../../../src/app/menu-bar/menu-bar.component.scss
// module chunks = 1